<app-header [forceLightBackground]="true"></app-header>
<div class="provider-manage-contribution">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="provider-manage-contribution--sidebar-col">
      <app-provider-sidebar></app-provider-sidebar>
    </div>
    <div class="provider-manage-contribution--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <app-manage-contribution 
        actionContext="provider"
        (reloadData)="reloadMyAssets()"
        (filterChange)="onFilterChange($event)"
        (requestData)="onRequestData($event)"
      ></app-manage-contribution>
    </div>
  </div>
</div>
